<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4">
                <h6>APPMART AGENT BANKING AGGREEMENT</h6>
                <p style="text-align:justify">THIS AGENT BANKING AGGREEMENT (this Aggreement) is made this
                    ..................... day of
                    ................... 2018 BETWEEN: Appmart Integrated Limited a Private limited company
                    incorporated under the laws of the federal republic of Nigeria with registered office address at
                    Road 2 House 46 Prince and Prince Estate, Duboyi District, FCT Abuja.
                    (hereinafter refered to as Appmart or "the Operator") of the One part;

                    AND a [Private limited company] incorporated under the laws of the federal republic of Nigeria with
                    registered office address at .......................... (hereinafter refered to as "the Agent") of
                    the other part.
                    (Appmart and the Agent are hereinafter jointly refered to as "Parties" and each a "Party")

                    RECITALS
                <ol>
                    <li>Appmart is lincesed by the central Bank of Nigeria </li>
                    <li>Appmart is desirous of engaging the services in connection with the provision of the Agent
                        Banking Services to its customers.</li>
                    <li>The Agent has agreed to provide the relevant Agency Services to Appmart.</li>
                    <li>In furtherance of the above, the parties have agreed to enter into this Aggreement, to
                        articulate the terms and conditions that will govern the provision of the Agency Services</li>
                </ol>
                NOW THEREFORE, In consideration of the mutual covenant and promises hereinafter set forth, the Parties
                agree as follows:
                18. GOVERNING LAW
                The provision of this Aggreement shall be governed by and constructed in accordance with the laws of the
                federal republic of Nigeria.
                IN WITNESS WHEREOF The parties hereto have caused this Aggreement to be made on the day and year first
                Above written.
                Signed, sealed and delivered by the authorized representatives of ..................................in
                the presence of:
                Name......................Name..........................Title............................
                title........................Signature.....................Signature......................
                Phone...............................Phone............................Date...........................
                Date....................................
                Signed, Sealed and Delivered by the authorized representatives of the within named APPMART Integrated
                LIMITED in the Presence of:
                </p>
            </div>
            <div class="col-lg-4">
                <p style="text-align:justify">
                    Name .......................................Name......................................Title
                    .........................................Title:...................................Signature
                    ......................Signature........................Phone.....................Phone:......................
                    Date ......................Date........................
                    APPENDIX 1
                    (AGENCY SERVICES)
                    The Agency Services to be rendered by the Agent shall entail the following:
                <ol>
                    <li>Registration of Customers</li>
                    <p>
                        The Registration of customers for Appmart services at its Service point by:
                    <ol>
                        <li>Obtaining duly completed registration forms conatining customers personal information such
                            as name, address, email, telephone number, date of birth;</li>
                        <li>entering the customeers personal information on the Operator user application on its
                            designated phone and confirm this informationwith their PIN Number;</li>
                        <li>Installation of the Appmart Software on the customeers Mobile equipment and ensuring same is
                            working at th time of registration;</li>
                        <li>collection of the documentation sufficient to prove such customrs identity including utility
                            bills, international passport, driving liscence etc and such other information as may be
                            required by Appmart, from time to time.</li>

                    </ol>
                    </p>
                    <li>Customer Assistance:
                        <ol>
                            <li>The Agent shall be responsible for the education and orientation of the customeer as to
                                the use of the Appmart Services.</li>
                            <li>The Agent shall assist any agent and customeer who encounter a problem with a
                                transaction on its account and may contact appmart for more enquieries</li>
                        </ol>
                    </li>
                </ol>
                PRIVACY POLICY CLAUSE
                Appmart is firmly committed to protecting the privacy of information supplied by the Agents as such
                Appmart shall ensure the protection of any data or information supplied to it in accordance with Nigeria
                Data protection Regulation 2019("NDPR") (as may be Amended, replaced or re-enacted from time to time)and
                any other law or regulation governing Data Protection the information may include personal data and
                sensitive personal data as defined in the NDPR.

                The Agent hereby authorizes appmart to collect, record, use share and store all data or personal
                information and financial supplied by the Agent. The Agent further permits Appmart to share any data or
                information supplied with any statustory, government or regulatory body, as required by law or for other
                legitimate purpose
                </p>
            </div>
            <div class="col-lg-4">
                <p>
                    Each party aggreess to comply with all applicable privacy and data protection laws, rules and
                    regulation in connection with performing its Obligation, responsibilities and duties which are
                    connected to this Aggreement. Each party shall implement and maintain comprehensive written
                    information security policies, procedures and processes that comply with all applicable privacy and
                    data protection laws and that include technical, physical operational and organization measures and
                    safeguards designed to: (i) ensure the security and confidentiality of third party's personal data;
                    and (ii) protect against any actual, anticipated or suspected loss of or threats to personal data or
                    unauthorized or unlawful processing of any personal data.

                    The Agent warrants and represents that the data and information supplied will not:
                    <ol>
                        <li>Breach the provisions of any Applicable Laws</li>
                        <li>Infringe the intellectual property rights or other legal rights of any person</li>
                        <li>Be made in breach of any legal duty owed to a duty of confidence.</li>
                        <li>Be deliberately or knowingly false, inaccurate or misleading, and/or</li>
                        <li>give rise to any cause of action against Appmart.</li>
                    </ol>
                    Upon termination of the agency banking relationship, closure of account or withdrawal of 
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>